import React from "react";
import PropTypes from "prop-types";
import { FormRow } from "./FormRow";
import { FormRowBtn } from "./FormRowBtn";

export const SubmitBtn = ({ text }) => (
  <FormRow>
    <FormRowBtn type="submit">{text}</FormRowBtn>
  </FormRow>
);

SubmitBtn.propTypes = {
  text: PropTypes.string.isRequired
};

export default SubmitBtn;
